import { z } from 'zod'
import { ContentfulAssetSchema } from './asset'

export const ContentfulAviosOnlyPromotionContentSchema = z.object({
  title: z.string(),
  introduction: z.string(),
  descriptionPart1: z.string(),
  descriptionPart2: z.string(),
  descriptionPart3: z.string(),
  aviosAmount: z.string(),
  image: ContentfulAssetSchema,
  resultsBanner: z.string(),
  fromAirportCode: z.string(),
  toAirportCode: z.string(),
  outboundDate: z.string(),
  inboundDate: z.string(),
  outboundFlightNumber: z.string(),
  inboundFlightNumber: z.string(),
})

export type ContentfulAviosOnlyPromotionContent = z.infer<
  typeof ContentfulAviosOnlyPromotionContentSchema
>
